<div class="container">
  <div>
    <tools-inline-refresh [autoRefreshInterval]="5 * 60"
      (refresh)="onRefreshSettingsChanged($event)"></tools-inline-refresh>
  </div>
  <div class="graphs">
    <div class="group-server-info">
      <div class="nav-heading">
        <mat-card (click)="selectGroup()"
          [ngClass]="{ unselected: currentlySelected != 'group', selected: currentlySelected == 'group' }">{{
          detailsNavOptions[0].Text }}
        </mat-card>
      </div>
      <mat-divider></mat-divider>
      <div class="nav-main">
        @if (detailsNavOptions != null && detailsNavOptions[0].Links.length > 0) {
        <mat-list role="list">
          @for (item of detailsNavOptions[0]['Links']; track item; let i = $index) {
          <mat-list-item role="listitem" [ngClass]="{ active: item.Active }" (click)="pageClicked(item)">
            <div class="item-text">
              {{ item.Text }}
              @if (item.Active) {
                <mat-icon>arrow_right</mat-icon>
              }
            </div>
          </mat-list-item>
          }
        </mat-list>
        }
      </div>
    </div>
    <div class="transactions-dashboard">
      <div class="tiles">
        @for (item of dashboardDetails; track item) {
        <mat-card class="card">
          <mat-card-header>
            {{ item.header }}
          </mat-card-header>
          <mat-card-content>
            <div>
              <div class="card-text">
                <span class="right-text">{{ item.value }}</span>
              </div>
            </div>
            @if (!item) {
            <mat-spinner [diameter]="30" class="small-spinner-container"></mat-spinner>
            }
          </mat-card-content>
        </mat-card>
        }
      </div>
      <mat-card class="top-header">
        <div class="last-updated"> Last Updated: {{ this.tools.FormatDateTimeFromDateSwedish(now) }} </div>
        @if (!loading) {
        <div>
          @if (currentTimeInterval != -1 && currentTimePeriod != -1 ) {
          <tools-time-frame-selector [selectedTimeFrame]="defaultTimeFrame" [selectedInterval]="defaultInterval"
            [selectedTimePeriod]="defaultTimePeriod" [timeFrameOptions]="timeFrameOptions"
            [timePeriodOptions]="timePeriodOptions" [intervalDisabled]="intervalDisabled"
            [timeFrameDisabled]="timeFrameDisabled" (intervalChanged)="timeVariableChanged($event, 1)"
            (timeFrameChanged)="timeVariableChanged($event, 3)"
            (timePeriodChanged)="timeVariableChanged($event, 2)"></tools-time-frame-selector>
          } @if (showDateRange) {
          <mat-form-field>
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate matInput placeholder="Start date" #dateRangeStart [value]="currentStartDate" />
              <input matEndDate matInput placeholder="End date" #dateRangeEnd [value]="currentEndDate"
                (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          }
          @if (currentlySelected != 'group') {
          <mat-divider></mat-divider>
          } @if (currentlySelected != 'group') {
          <div class="server-toggles">
            <div class="outgoinglink">
              <mat-form-field class="next-level">
                <mat-label>Incoming link</mat-label>
                <mat-select [(value)]="serverLinkID" (valueChange)="transactionChanged($event, true)">
                  @for (option of incomingServerLinks; track option) {
                  <mat-option [value]="option.ID">{{ option.Label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="outgoinglink">
              <mat-form-field class="next-level">
                <mat-label>Outgoing link</mat-label>
                <mat-select [disabled]="outGoingServerLinks.length == 1" [value]="outgoingLinkID"
                  (valueChange)="transactionChanged($event, false)">
                  @for (option of outGoingServerLinks; track option) {
                  <mat-option [value]="option.ID">{{ option.Label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="set-button">
              <button mat-raised-button class="button-left" (click)="updateGraph()"><i
                  class="material-icons">filter_alt</i> Apply filter</button>
            </div>
          </div>
          } @if ((currentlySelected == 'serverLink' || currentlySelected == 'outgoingLink') && serverLinkID != -1) {
          <div class="link-description">
            <h3>Server Link Description: {{ linkDescription ?? 'No Description' }}</h3>
          </div>
          }
        </div>
        }

        @if (loading) {
        <mat-spinner></mat-spinner>
        }
      </mat-card>
      <mat-tab-group class="grid" dynamicHeight animationDuration="0ms">
        <mat-tab label="Tab 1">
          <ng-template matTabContent>
            @if (!outageSelected) {
            <div class="conconn" (click)="enlargeGraph('Success', $event)">
              @if (STransactionsGraphConfig.IsReady) {
              <div>
                <app-generic-graph-handler [graphData]="STransactionsGraphConfig" [showTools]="false">
                </app-generic-graph-handler>
              </div>
              } @if (!STransactionsGraphConfig.IsReady) {
              <app-skeleton-loader [height]="5"> </app-skeleton-loader>
              }
            </div>
            } @if (!outageSelected) {
            <div class="nested-graph" (click)="enlargeGraph('Null', $event)">
              @if (NTransactionsGraphConfig.IsReady) {
              <div>
                <app-generic-graph-handler #TxRxGraph [graphData]="NTransactionsGraphConfig" [showTools]="false">
                </app-generic-graph-handler>
              </div>
              } @if (!STransactionsGraphConfig.IsReady) {
              <app-skeleton-loader [height]="5"> </app-skeleton-loader>
              }
            </div>
            }
            <div class="nested-graph" (click)="enlargeGraph('Outage', $event)">
              @if (OTransactionsGraphConfig.IsReady) {
              <div>
                <app-generic-graph-handler #TxRxGraph [graphData]="OTransactionsGraphConfig" [showTools]="false">
                </app-generic-graph-handler>
              </div>
              } @if (!STransactionsGraphConfig.IsReady) {
              <app-skeleton-loader [height]="5"> </app-skeleton-loader>
              }
            </div>
            @if (!outageSelected) {
            <div class="nested-graph" (click)="enlargeGraph('Fail', $event)">
              @if (FTransactionsGraphConfig.IsReady) {
              <div>
                <app-generic-graph-handler #TxRxGraph [graphData]="FTransactionsGraphConfig" [showTools]="false">
                </app-generic-graph-handler>
              </div>
              } @if (!FTransactionsGraphConfig.IsReady) {
              <app-skeleton-loader [height]="5"> </app-skeleton-loader>
              }
            </div>
            }
          </ng-template>
        </mat-tab>

        <mat-tab label="Tab 2">
          <ng-template matTabContent>
            @if (!outageSelected) {
            <div class="conconn" (click)="enlargeGraph('Conn', $event)">
              @if (ConcurrentConnectionsGraphConfig.IsReady) {
              <div>
                <app-generic-graph-handler #ConcurrentConnectionsGraph [graphData]="ConcurrentConnectionsGraphConfig"
                  [showTools]="false"> </app-generic-graph-handler>
              </div>
              } @if (!ConcurrentConnectionsGraphConfig.IsReady) {
              <app-skeleton-loader [height]="5"> </app-skeleton-loader>
              }
            </div>
            }

            <div class="split">
              @if (!outageSelected) {
              <div class="nested-graph" (click)="enlargeGraph('Tx', $event)">
                @if (TxGraphConfig.IsReady) {
                <div>
                  <app-generic-graph-handler #TxRxGraph [graphData]="TxGraphConfig" [showTools]="false">
                  </app-generic-graph-handler>
                </div>
                } @if (!TxGraphConfig.IsReady) {
                <app-skeleton-loader [height]="5"> </app-skeleton-loader>
                }
              </div>
              } @if (!outageSelected) {
              <div class="nested-graph" (click)="enlargeGraph('Rx', $event)">
                @if (RxGraphConfig.IsReady) {
                <div>
                  <app-generic-graph-handler #TxRxGraph [graphData]="RxGraphConfig" [showTools]="false">
                  </app-generic-graph-handler>
                </div>
                } @if (!RxGraphConfig.IsReady) {
                <app-skeleton-loader [height]="5"> </app-skeleton-loader>
                }
              </div>
              }
            </div>
            <div class="conn">
              @if (!outageSelected) {
              <div (click)="enlargeGraph('TotalTrans', $event)">
                @if (TotalTransactionsGraphConfig.IsReady) {
                <div>
                  <app-generic-graph-handler #TxRxGraph [graphData]="TotalTransactionsGraphConfig" [showTools]="false">
                  </app-generic-graph-handler>
                </div>
                } @if (!TotalTransactionsGraphConfig.IsReady) {
                <app-skeleton-loader [height]="5"> </app-skeleton-loader>
                }
              </div>
              }
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>